module.exports = __webpack_public_path__ + "static/img/back-card.eccfbc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/back-card.png
// module id = 1000
// module chunks = 0